// extracted by mini-css-extract-plugin
export var quantityInput = "_ko-0";